<div class="cr-modal__backdrop" (click)="onBackdrop($event)" role="dialog" aria-modal="true" aria-labelledby="suchtyp-title">
  <div class="cr-modal__sheet">
    <div class="cr-modal__grabber" aria-hidden="true"></div>

    <header class="cr-modal__header">
      <div>
        @if (gewerkLabel || ortLabel) {
          <div class="cr-modal__context">
            @if (gewerkLabel) {
              <span class="cr-modal__chip cr-mono">{{ gewerkLabel }}</span>
            }
            @if (gewerkLabel && ortLabel) { <span aria-hidden="true">·</span> }
            @if (ortLabel) { <span>{{ ortLabel }}</span> }
          </div>
        }
        <h2 id="suchtyp-title" class="cr-modal__title cr-display">Wie möchtest du weitermachen?</h2>
      </div>
      <button type="button" class="cr-modal__close" (click)="closed.emit()" aria-label="Schließen">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      </button>
    </header>

    <div class="cr-modal__cards">
      <!-- Card A · Geführte Anfrage (full width, hero) -->
      <button type="button" class="cr-card cr-card--primary" (click)="guidedSelected.emit()">
        <span class="cr-card__glow" aria-hidden="true"></span>
        <span class="cr-card__row">
          <span class="cr-card__pill cr-card__pill--brass">Empfohlen</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--cr-brass-500)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" />
          </svg>
        </span>
        <span class="cr-card__head">
          <span class="cr-card__title cr-display">Geführte Anfrage</span>
          <span class="cr-card__lead">Beschreibe deinen Auftrag einmal — wir matchen dich mit passenden Betrieben, die dir ihre Angebote schicken.</span>
        </span>
        <span class="cr-card__bullets">
          <span class="cr-card__bullet">
            <span class="cr-card__bullet-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--cr-brass-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 7a8 8 0 1 0 0 10M3 10h11M3 14h11"/></svg>
            </span>
            Mehrere Angebote im Vergleich
          </span>
          <span class="cr-card__bullet">
            <span class="cr-card__bullet-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--cr-brass-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
            </span>
            Ein Formular, mehrere Antworten
          </span>
          <span class="cr-card__bullet">
            <span class="cr-card__bullet-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--cr-brass-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>
            </span>
            Nur qualitätsgeprüfte Betriebe
          </span>
        </span>
        <span class="cr-card__foot">
          <span class="cr-card__foot-meta">ca. 30 s · kostenlos</span>
          <span class="cr-card__foot-cta">
            Anfrage starten
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          </span>
        </span>
      </button>

      <!-- Divider -->
      <div class="cr-modal__divider" aria-hidden="true">
        <span class="cr-modal__divider-line"></span>
        <span class="cr-modal__divider-text">oder</span>
        <span class="cr-modal__divider-line"></span>
      </div>

      <!-- Card B · Selbst suchen (compact, low-emphasis) -->
      <button type="button" class="cr-card cr-card--compact" (click)="selfSelected.emit()">
        <span class="cr-card__compact-icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>
          </svg>
        </span>
        <span class="cr-card__compact-text">
          <span class="cr-card__compact-title">Lieber selbst suchen</span>
          <span class="cr-card__compact-lead">Profile vergleichen und direkt buchen.</span>
        </span>
        <svg class="cr-card__compact-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 12h14M13 5l7 7-7 7"/>
        </svg>
      </button>
    </div>

    <p class="cr-modal__footnote">Beide Wege sind kostenlos und unverbindlich · DSGVO-konform</p>
  </div>
</div>
